import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Address } from '../models/address';
import { EnvironmentLoaderService } from './environment-loader.service';

@Injectable({
  providedIn: 'root',
})
export class AddressLookupService {
  private http = inject(HttpClient);
  private environmentLoaderService = inject(EnvironmentLoaderService);

  apiURL: string;

  constructor() {
    this.apiURL = this.environmentLoaderService.config['serviceBaseUrl'] + '/api/v1/';
  }

  lookup(query: string): Observable<Address[]> {
    if (!query || query.length < 2) {
      return of([]);
    }

    const url = `${this.apiURL}AddressLookup`;
    let params = new HttpParams();
    params = params.append('query', query);

    return this.http.get<Address[]>(url, {
      params,
    });
  }
}
